import { Modal, useModalContext } from '../index'
import { Button } from '@highlight/ui'

export const DeleteConfirmationModal = () => {
  const { context, close } = useModalContext('delete-confirmation')

  function handleConfirm() {
    context.onConfirm()
    close()
  }

  return (
    <Modal confirm>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Delete Item</Modal.Title>
          <Modal.Description>
            {context.confirmationText || 'Are you sure you want to delete this item?'}
          </Modal.Description>
        </Modal.Header>
        <Modal.Footer>
          <Modal.Close variant="secondary">Cancel</Modal.Close>
          <Button variant="primary" tone="danger" onClick={handleConfirm} disabled={context.isPending}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  )
}
